import React from "react";
import classNames from "classnames";
import sellTagService from "../../../../js/common/SellTagService";
import { FilterValues, SellTagFilterSource } from "./FilterValuesCollection";

interface ProductListSellTagsFilterProperties {
    readonly isActive: boolean;
    readonly sellTags: SellTagFilterSource[];
    readonly filter: FilterValues;
    readonly isSoldProductsPage: boolean;

    readonly onFilterChange: (filter: FilterValues) => void;
    readonly onActivateTab: () => void;
}

export default function ProductListSellTagsFilter({
    isActive,
    sellTags,
    filter,
    isSoldProductsPage,
    onFilterChange,
    onActivateTab,
}: ProductListSellTagsFilterProperties): React.JSX.Element | undefined {
    if (sellTags.length === 0 || isSoldProductsPage) {
        return undefined;
    }

    const handleSellTagToggle = (sellTag: number): void => {
        let currentSellTags: number | undefined = filter.SellTags ?? 0;

        // eslint-disable-next-line no-bitwise
        currentSellTags = sellTagService.contains(currentSellTags, sellTag) ? currentSellTags & ~sellTag : currentSellTags | sellTag;

        if (filter.SellTags === 0) {
            currentSellTags = undefined;
        }

        onFilterChange(Object.assign({}, filter, { SellTags: currentSellTags }));
    };

    return (
        <div className="filter-widget">
            <h2 className={isActive ? "active" : undefined} onClick={onActivateTab}>Štítky<i className="fa-solid fa-caret-down"></i></h2>

            <div className={classNames("widget-content", "category-checkbox", { hidden: !isActive })}>
                {sellTags.map((sellTag) => <div className="filter-container label-inner" key={sellTag.value}>
                    <label htmlFor={`_fs_${sellTag.value}`}>
                        <span className="label-filter" style={{ backgroundColor: sellTag.color }}>
                            <input
                                type="checkbox"
                                id={`_fs_${sellTag.value}`}
                                value={sellTag.value}
                                onChange={() => handleSellTagToggle(sellTag.value)}
                                checked={filter.SellTags !== undefined && sellTagService.contains(filter.SellTags, sellTag.value)} />
                            <span className="checkmark"></span>
                            {sellTag.symbol !== null && <><i className={sellTag.symbol}></i>&nbsp;</>}
                            {sellTag.label}
                        </span>
                    </label>
                </div>)}
            </div>

        </div>);
}
